/**
 * LUM Slide Cart v3.0
 * Shopify Cart API — reads from /cart.js, writes via /cart/change.js
 * Replaces sessionStorage-based v2.0
 */
(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0705/6474/1235/files/';

  /* ── Money formatter ─────────────────────────────────── */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ── Badge ───────────────────────────────────────────── */
  function updateBadge(count) {
    document.querySelectorAll('#lum-cart-badge').forEach(function (b) {
      if (count > 0) { b.textContent = count; b.style.display = 'flex'; }
      else { b.style.display = 'none'; }
    });
  }

  function refreshBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { updateBadge(c.item_count); })
      .catch(function () {});
  }

  /* ── Inject cart shell once ──────────────────────────── */
  function injectCart() {
    if (document.getElementById('lumSlideCart')) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = [
      '<div id="lumCartOverlay" onclick="closeSlideCart()" style="display:none;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:998;opacity:0;transition:opacity .3s ease;"></div>',
      '<div id="lumSlideCart" role="dialog" aria-label="Your cart" aria-modal="true" style="',
        'position:fixed;top:0;right:0;width:400px;max-width:100vw;height:100%;',
        'background:#fff;z-index:999;transform:translateX(100%);',
        'transition:transform .32s cubic-bezier(.4,0,.2,1);',
        'display:flex;flex-direction:column;',
        'box-shadow:-8px 0 48px rgba(0,0,0,.18);',
        "font-family:'Barlow',sans-serif;\">",
        /* header */
        '<div style="padding:0 20px;border-bottom:1px solid #e5e7eb;flex-shrink:0;">',
          '<div style="display:flex;align-items:center;justify-content:center;position:relative;height:56px;">',
            '<span style="font-size:13px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#273166;">',
              'Your Cart (<span id="lumCartQtyLabel">0</span>)',
            '</span>',
            '<button onclick="closeSlideCart()" aria-label="Close" style="position:absolute;right:0;background:none;border:none;cursor:pointer;color:#6b7280;font-size:22px;padding:4px;line-height:1;font-family:inherit;">&#10005;</button>',
          '</div>',
          '<div style="background:#273166;color:#86ccd8;text-align:center;padding:8px 16px;font-size:12px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;margin:0 -20px;">&#127881; You\'ve unlocked FREE SHIPPING!</div>',
        '</div>',
        /* body */
        '<div id="lumCartBody" style="flex:1;overflow-y:auto;padding:20px;"></div>',
        /* footer */
        '<div id="lumCartFooter" style="border-top:1px solid #e5e7eb;padding:16px 20px 20px;flex-shrink:0;background:#fff;display:none;">',
          '<div style="margin-bottom:14px;">',
            '<div style="display:flex;justify-content:space-between;padding:4px 0;font-size:14px;">',
              '<span style="font-weight:600;color:#3a3a3b;">Subtotal</span>',
              '<span style="font-weight:700;color:#3a3a3b;" id="lumCartSubtotal">$0</span>',
            '</div>',
            '<div style="display:flex;justify-content:space-between;padding:4px 0;font-size:14px;">',
              '<span style="font-weight:600;color:#3a3a3b;">Shipping</span>',
              '<span style="font-weight:700;color:#273166;">FREE</span>',
            '</div>',
          '</div>',
          '<a href="javascript:void(0)" onclick="getCart()" style="',
            'display:block;width:100%;height:52px;line-height:52px;text-align:center;',
            'background:linear-gradient(90deg,#FF6BB5 0%,#A78BFA 50%,#5EEAD4 100%);',
            'color:#fff;border-radius:8px;font-size:15px;font-weight:800;letter-spacing:.06em;',
            "text-transform:uppercase;text-decoration:none;margin-bottom:10px;font-family:'Barlow',sans-serif;\">",
            'CHECKOUT NOW &#128274;',
          '</a>',
          '<div style="text-align:center;font-size:12px;color:#6b7280;line-height:1.7;">',
            '<span style="color:#f59e0b;">&#9733;&#9733;&#9733;&#9733;&#9733;</span>&nbsp; 52,000+ Happy Customers<br>',
            '&#10003; 60-Night Satisfaction Guarantee',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
    while (wrap.firstChild) document.body.appendChild(wrap.firstChild);
  }

  /* ── Bonus items ─────────────────────────────────────── */
  function bonusesHTML() {
    var bonuses = [
      [CDN + 'lum-program-v3.jpg',   '60 Nights Perfect Sleep Transformation Program'],
      [CDN + 'lum-program-v5.jpg',   'Sleep Cycle App Access'],
      [CDN + 'kit-sleep-expert.jpg', 'Personal Sleep Expert Coaching — 24/7 Text Access'],
      [CDN + 'Lum-unboxing-v6.jpg',  'Upgraded Custom Unboxing Experience'],
    ];
    var h = '<hr style="border:none;border-top:1px solid #e5e7eb;margin:16px 0;"/>';
    h += '<div style="font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#6b7280;margin-bottom:14px;">&#127873; Free bonuses included</div>';
    bonuses.forEach(function (b) {
      h += [
        '<div style="display:flex;align-items:center;gap:12px;padding:8px 0;border-bottom:1px solid #f5f5f5;">',
          '<div style="width:44px;height:44px;border-radius:8px;flex-shrink:0;overflow:hidden;background:linear-gradient(135deg,#273166,#7660a9);">',
            '<img src="' + b[0] + '" alt="' + b[1] + '" style="width:100%;height:100%;object-fit:cover;display:block;" onerror="this.style.display=\'none\'">',
          '</div>',
          '<span style="flex:1;font-size:12px;font-weight:600;color:#3a3a3b;line-height:1.35;">' + b[1] + '</span>',
          '<span style="font-size:11px;font-weight:700;color:#10b981;text-transform:uppercase;white-space:nowrap;">FREE</span>',
        '</div>'
      ].join('');
    });
    return h;
  }

  /* ── Render from Shopify cart ────────────────────────── */
  function renderCart(cart) {
    var body   = document.getElementById('lumCartBody');
    var qtyLbl = document.getElementById('lumCartQtyLabel');
    var sub    = document.getElementById('lumCartSubtotal');
    var footer = document.getElementById('lumCartFooter');
    if (!body) return;

    updateBadge(cart.item_count);
    if (qtyLbl) qtyLbl.textContent = cart.item_count;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = [
        '<div style="text-align:center;padding:48px 20px;color:#6b7280;">',
          '<div style="font-size:52px;margin-bottom:16px;">&#128722;</div>',
          '<div style="font-size:15px;font-weight:700;color:#273166;margin-bottom:8px;">Your cart is empty</div>',
          '<div style="font-size:13px;margin-bottom:28px;">Add L\xdcM N3 Complex to get started</div>',
          '<a href="/products/lum-n3-complex-deep-sleep-gummies" data-age-gate style="display:inline-block;background:linear-gradient(90deg,#FF6BB5 0%,#A78BFA 50%,#5EEAD4 100%);color:#fff;font-size:14px;font-weight:700;padding:12px 28px;border-radius:8px;text-decoration:none;font-family:Barlow,sans-serif;">Shop Now &rarr;</a>',
        '</div>'
      ].join('');
      if (footer) footer.style.display = 'none';
      return;
    }

    if (sub) sub.textContent = money(cart.total_price);
    if (footer) footer.style.display = 'block';

    var itemsHTML = '';
    cart.items.forEach(function (item) {
      var img = (item.featured_image && item.featured_image.url)
        ? item.featured_image.url
        : CDN + 'lum-gummies-n3-complex.jpg';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div style="font-size:12px;color:#6b7280;margin-bottom:6px;">' + item.variant_title + '</div>'
        : '';
      itemsHTML += [
        '<div style="display:flex;gap:14px;margin-bottom:20px;">',
          '<div style="position:relative;flex-shrink:0;">',
            '<div style="width:68px;height:68px;border-radius:10px;overflow:hidden;background:linear-gradient(135deg,#273166,#7660a9);">',
              '<img src="' + img + '" alt="' + item.product_title + '" style="width:100%;height:100%;object-fit:cover;display:block;" onerror="this.style.display=\'none\'">',
            '</div>',
            '<span style="position:absolute;top:-6px;right:-6px;background:#20498f;color:#fff;font-size:11px;font-weight:700;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:2px solid #fff;">' + item.quantity + '</span>',
          '</div>',
          '<div style="flex:1;min-width:0;">',
            '<div style="font-size:14px;font-weight:700;color:#3a3a3b;margin-bottom:3px;line-height:1.3;">' + item.product_title + '</div>',
            variant,
            '<div style="font-size:16px;font-weight:800;color:#273166;margin-bottom:8px;">' + money(item.final_price) + '</div>',
            '<div style="display:flex;align-items:center;justify-content:space-between;">',
              '<div style="display:flex;align-items:center;border:1px solid #e5e7eb;border-radius:6px;overflow:hidden;">',
                '<button onclick="lumChangeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" style="background:#f5f5f7;border:none;width:28px;height:28px;font-size:16px;cursor:pointer;color:#3a3a3b;font-family:inherit;">\u2212</button>',
                '<span style="width:32px;text-align:center;font-size:14px;font-weight:600;color:#3a3a3b;">' + item.quantity + '</span>',
                '<button onclick="lumChangeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" style="background:#f5f5f7;border:none;width:28px;height:28px;font-size:16px;cursor:pointer;color:#3a3a3b;font-family:inherit;">+</button>',
              '</div>',
              '<button onclick="lumChangeQty(\'' + item.key + '\',0)" style="font-size:12px;color:#6b7280;text-decoration:underline;background:none;border:none;cursor:pointer;font-family:Barlow,sans-serif;">Remove</button>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    });

    body.innerHTML = itemsHTML + bonusesHTML();
  }

  /* ── Cart mutation ───────────────────────────────────── */
  window.lumChangeQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function (e) { console.error('Cart update failed', e); });
  };

  /* ── Open / close ────────────────────────────────────── */
  window.openSlideCart = function () {
    injectCart();
    var ov = document.getElementById('lumCartOverlay');
    var sc = document.getElementById('lumSlideCart');
    var body = document.getElementById('lumCartBody');
    if (!ov || !sc) return;

    // Show drawer immediately with loading state
    if (body) body.innerHTML = '<div style="text-align:center;padding:40px 20px;color:#6b7280;font-size:14px;">Loading&hellip;</div>';
    ov.style.display = 'block';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        ov.style.opacity = '1';
        sc.style.transform = 'translateX(0)';
      });
    });
    document.body.style.overflow = 'hidden';

    // Fetch real cart
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {
        if (body) body.innerHTML = '<div style="text-align:center;padding:40px 20px;color:#e53e3e;font-size:13px;">Could not load cart. Please refresh.</div>';
      });
  };

  window.closeSlideCart = function () {
    var ov = document.getElementById('lumCartOverlay');
    var sc = document.getElementById('lumSlideCart');
    if (!ov || !sc) return;
    ov.style.opacity = '0';
    sc.style.transform = 'translateX(100%)';
    setTimeout(function () { ov.style.display = 'none'; }, 320);
    document.body.style.overflow = '';
  };

  /* ── Keyboard close ──────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeSlideCart();
  });

  /* ── Badge on load ───────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshBadge);
  } else {
    refreshBadge();
  }

})();
